// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js_iax/" + chunkId + "." + "e191f5b3" + ".chunk.js";
};